import StudioPage from "@/components/marketing/products/studio/StudioPage"

type Props = {}

const index = (_props: Props) => {
  return <StudioPage />
}

export default index
